<template>
  <div class="home">
    <div class="top-img-box">
      <img class="img-item" src="./../assets/images/1.jpg" alt="">
    </div>
    <div class="middle-tab">
      <div class="top-img-item" @click="toList">
        <img class="img-item" src="./../assets/images/1.jpg" alt="">
        <!-- <div class="img-item-type">女士手袋</div>
        <div style="text-decoration: underline;cursor: pointer;">即刻选购</div> -->
      </div>
      <div class="top-img-item" @click="toList">
        <img class="img-item" src="./../assets/images/2.jpg" alt="">
        <!-- <div class="img-item-type">时尚首饰</div>
        <div style="text-decoration: underline;cursor: pointer;">即刻选购</div> -->
      </div>
      <div class="top-img-item" @click="toList">
        <img class="img-item" src="./../assets/images/3.jpg" alt="">
        <!-- <div class="img-item-type">男士包袋</div>
        <div style="text-decoration: underline;cursor: pointer;">即刻选购</div> -->
      </div>
    </div>
    <div class="bottom-img-item">
      <img src="./../assets/images/5.jpg" alt="" class="img-item">
    </div>
    <!-- <div class="bottom-img-item">
      <img src="./../assets/images/banner-3-2.jpg" alt="" class="img-item">
    </div>
    <div class="bottom-img-item">
      <img src="./../assets/images/banner-3-3.jpg" alt="" class="img-item">
    </div> -->
  </div>
</template>

<script>

export default {
  name: "Home",
  data(){
    return {
      scroll: 0,
      footerArr: [
        { label: '帮助' },
        { label: '订制与赠礼服务' },
        { label: '路易威登的世界' },
        { label: '关注我们' },

        { label: '欢迎致电 400 6588 555 联系咨询顾问。您还可以给我们 发送消息 或 发电子邮件' },
        { label: '维修' },
        { label: '最新消息' },
        { label: '订阅电子报 以抢先访问最新系列、活动和视频。' },

        { label: '常见问题解答' },
        { label: '个性化定制' },
        { label: '时装秀' },
        { label: '关注社交账号' },

        { label: '产品保养' },
        { label: '个性化赠礼' },
        { label: '艺术与文化' },
        { label: '艺术与文化' },
        
        { label: '下载我们的应用程序' },
        { label: '品牌' },
        { label: '环保与可持续性' },
        { label: '路易威登基金会' },
      ]
    }
  },
  mounted() {
    this.$store.commit('updateCount')
    window.addEventListener('scroll', this.dataScroll, false);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.dataScroll, false)
  },
  methods:{
    dataScroll: function () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    toList() {
      this.$router.push('/List')
    }
    
  }
};
</script>

<style scoped lang="less">
.home {
  height: 100%;
}
.headerStyle {
  transition: all .3s cubic-bezier(.39,.575,.565,1);
  box-shadow: inset 0 -1px 0 0 #eae8e4;
  background: #fff;
}
.home-header {
  width: 100%;
  height: 130px;
  padding: 0 3.125vw;
  position: fixed;
  left: 0;
  top: 0;
  .header-title {
    display: flex;
    align-items: center;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    font-size: 46px;
    font-weight: bold;
    color: #fff;
  }
  .header-control {
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: 40px;
    font-size: 20px;
    cursor: pointer;
    .header-control-item {
      color: #fff;
    }
  }
}

.top-img-box {
  width: 100%;
  height: 900px;
  background: #b49a9a;
  position: relative;
  overflow: hidden;
}

.img-item {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.middle-tab {
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 3.125vw;
  .top-img-item {
    flex: 1 1 0;
    font-size: 16px;
    position: relative;
    height: 600px;
    img {
      width: 100%;
      height: 600px;
      background: #b49a9a;
    }
    .img-item-type {
      cursor: pointer;
      margin-top: 40px;
      margin-bottom: 20px;
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
}

.bottom-img-item {
  height: 600px;
  background: #b49a9a;
  margin-bottom: 40px;
  position: relative;
}

.footer-header {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-bottom: 40px;
  padding-top: 40px;
  padding-left: 4.6875vw;
  padding-right: 4.6875vw;
}

.footer-header-item {
  width: calc(25% - 8px);
  font-size: 18px;
  margin-bottom: 10px;
}
</style>